module.exports = __webpack_public_path__ + "img/html5.90a5580c.svg";